// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__ixYmw","box":"WorkspacesBox_box__3Bel9","node":"WorkspacesBox_node__3KcXD"};